// 发票类型
export enum CheckType {
    '待审核',
    '审核通过',
    '驳回'
}